import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@musa.tech/design-system";
import { Card, CardContent } from "@/components/ui/card";
import { ProfileForm } from "@/components/Users/ProfileForm";
import { useProfile } from "@/hooks/useProfile";

const FORM_ID = "profile-form";

const MeuPerfil = () => {
  const navigate = useNavigate();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const {
    profile,
    isLoading,
    updateProfile,
    isUpdatingProfile,
  } = useProfile();

  const handleProfileSubmit = (data: {
    firstName: string;
    lastName: string;
    phone_number: string | null;
  }) => {
    const fullName = `${data.firstName} ${data.lastName}`.trim();
    updateProfile({
      user_name: fullName,
      phone_number: data.phone_number,
    });
  };

  return (
    <div className="min-h-screen bg-background p-4 md:p-6 w-full overflow-x-hidden">
      <div className="max-w-2xl mx-auto space-y-4 md:space-y-6">
        {/* Header */}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-1 rounded-md hover:bg-accent transition-colors"
            >
              <ArrowLeft className="h-6 w-6 text-[#10261F]" />
            </button>
            <h1 className="text-2xl md:text-3xl font-bold text-[#10261F]">
              Meu Perfil
            </h1>
          </div>
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            Visualize e atualize suas informações pessoais.
          </p>
        </div>

        {/* Content */}
        {isLoading || !profile ? (
          <div className="flex items-center justify-center py-12">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          </div>
        ) : (
          <>
            <Card>
              <CardContent className="pt-6">
                <ProfileForm
                  key={`${profile.user_id}-${profile.phone_number || "no-phone"}`}
                  profile={profile}
                  onSubmit={handleProfileSubmit}
                  isLoading={isUpdatingProfile}
                  formId={FORM_ID}
                  onDirtyChange={setIsFormDirty}
                />
              </CardContent>
            </Card>

            <div className="flex justify-end">
              <Button
                form={FORM_ID}
                type="submit"
                disabled={!isFormDirty || isUpdatingProfile}
              >
                {isUpdatingProfile && (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                )}
                Salvar Alterações
              </Button>
            </div>

          </>
        )}
      </div>
    </div>
  );
};

export default MeuPerfil;
